export default __webpack_public_path__ + "static/media/ic_tlp1_96.702d96ec.svg";